module.exports = __webpack_public_path__ + "static/media/left-arrow-restaurant.ebc1a24b.svg";